module.exports = __webpack_public_path__ + "static/media/sub_icon_black.abe681bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sub_icon_black.svg
// module id = 1120
// module chunks = 0